var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,32.1h-7.2L144.7,0H17.9v223.9h39.4V256h180.8V86.2L184,32.1z M187.9,54.8l27.5,27.5h-27.5V54.8z  M158,32.1h-9.5v-9.5L158,32.1z M31.9,210.6V13.3h103.4v18.8h-78v178.5H31.9z M224.8,140.8V154v88.8H71.3V45.4h103.4v50.1h50.1 V140.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.7,
    y: 127,
    className: "st0",
    width: 94.7,
    height: 13.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.7,
    y: 154,
    className: "st0",
    width: 94.7,
    height: 13.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.3,
    y: 182.4,
    className: "st0",
    width: 94.7,
    height: 13.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/media/icon-documents.41c6437f.svg";
export { ForwardRef as ReactComponent };